<!--
 * @Descripttion: 
 * @Author: 老板说这个需求很简单
 * @Date: 2025-05-12 09:59:16
 * @LastEditTime: 2025-05-21 13:50:01
 * @LastEditors: sudo_rm_rf
-->
<script lang="ts" setup>
import Header from '/@/components/Header/index.vue';
import { onMounted, reactive, watch } from 'vue';

const props = defineProps({
  value: {
    type: String,
    default: '',
  },
});
onMounted(() => {
  // document.querySelector('#containerMain').style.height =
  //   document.querySelector('#containerBox').offsetHeight - document.getElementById('header').offsetHeight + 'px';
});
</script>

<template>
  <div class="container-box" id="containerBox">
    <Header id="header" />
    <div class="container-main-my" id="containerMain">
      <router-view v-slot="{ Component, route }">
        <keep-alive v-if="route.meta.keepAlive">
          <component :is="Component" />
        </keep-alive>
        <component :is="Component" v-else />
      </router-view>
    </div>
  </div>
</template>

<style lang="less" scoped>
.container-box {
  height: 100%;
  // background-image: url('/@/assets/imgs/login-background.jpg');
  background-size: cover;
}
.container-main-my {
  // background-color: #cbe5ff;
  padding: 16px;
  height: calc(100% - 56px - 32px);
}
</style>
